import storage from "redux-persist/lib/storage";
import {
  configureStore,
  ThunkAction,
  Action,
  combineReducers,
} from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import themeReducer from "../features/theme/themeSlice";
import credentialsReducer from "../features/credentials/credentialsSlice";
import tokenReducer from "../features/token/tokenSlice";
import messagesReducer from "../features/messages/messagesSlice";
import settingsReducer from "../features/settings/settingsSlice";

const reducers = combineReducers({
  theme: themeReducer,
  credentials: credentialsReducer,
  token: tokenReducer,
  messages: messagesReducer,
  settings: settingsReducer,
});

const persistConfig = {
  key: "root",
  storage,
  version: 1,
  whitelist: ["theme", "settings"],
  blacklist: ["credentials", "token", "messages"],
};

const persistedReducer = persistReducer(persistConfig, reducers);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    });
  },
});

export let persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
